angular
  .module('components', [
    'components.contact',
    'components.auth'
  ])
